import "./LargeImageButtonElement.less";

export class LargeImageButtonElement extends HTMLElement {
    static tag = "large-image-button";

    connectedCallback() {
        this.addEventListener("click", this.onClick);
    }

    private onClick = (event: MouseEvent) => { 
        event.preventDefault();
        event.stopPropagation();

        const imageUrl = this.getAttribute("large-image");
        if (!imageUrl) {
            console.error("Image URL is not set.");
            return;
        }

        document.body.insertAdjacentHTML("beforeend", this.view(imageUrl));
    }

    private view = (imagePath: string) => `
        <large-image id="revealAlert">

            <div class="content">
                <div style="text-align:center;"><img src="${imagePath}"></div>
                <a class="close-reveal-modal">&#215;</a>
            </div>
            
        </large-image>
    `;
}

customElements.define(LargeImageButtonElement.tag, LargeImageButtonElement);